import React from 'react';
import { Form, RadioGroup, RadioItem } from 'src/components/Antd';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const Item = Form.Item;
export enum EInclude {
  INCLUDE_ANY = 'INCLUDE_ANY',
  INCLUDE_ALL = 'INCLUDE_ALL',
}

const CommonProduct = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { noStyle, radioName } = props;
  return (
    <React.Fragment>
      <Item name={radioName} noStyle={noStyle}>
        <RadioGroup className={css.groupContainer}>
          <RadioItem className={css.item} value={EInclude.INCLUDE_ANY}>
            {getI18n(
              'general.advancedFilters.commonProductSelection.includeProduct',
            )}
          </RadioItem>
        </RadioGroup>
      </Item>
    </React.Fragment>
  );
};
export default CommonProduct;
